import { render, staticRenderFns } from "./ProfilePhotoBlock.vue?vue&type=template&id=5a1fe4c1&scoped=true&"
import script from "./ProfilePhotoBlock.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhotoBlock.vue?vue&type=style&index=0&id=5a1fe4c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fe4c1",
  null
  
)

export default component.exports